export default "__VITE_ASSET__e4c96dbd__"